import gql from 'graphql-tag';
export default gql`
  query creditCheck($param: String!, $applicationType: String) {
    creditCheck(param: $param, applicationType: $applicationType) {
      id_reference_internal
      status
      result
    }
  }
`;
